var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGreenArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.715 0h6.603s.85-.048.85.783v11.542s-.185.903 1.233.903h3.265s.666.034.117.564l-8.23 7.955s-.512.57-1.1 0L.09 13.653s-.336-.425.291-.425h3.671s.786.149.786-.992V.746S4.784 0 5.714 0z",
    fill: "#B5E0C7",
    fillRule: "nonzero"
  })));
}

export default SvgGreenArrow;